import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Modal, ModalHandle, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { AppStore } from '../Core/AppStore';
import { CreateOrEditWarehouseModal } from './CreateOrEditWarehouseModal';
import { WarehouseStore } from './WarehouseStore';
import { BsPencilSquare } from '@react-icons/all-files/bs/BsPencilSquare';
import { BsTrash } from '@react-icons/all-files/bs/BsTrash';

export interface IWarehouseRowProps {
    readonly warehouse: Mri.Warehouses.Warehouse;
}

@autoinject
@observer
export class WarehouseItem extends React.Component<IWarehouseRowProps> {
    public render() {
        return (
            <div className="card d-block h-100">
                <div className="card-body p-1 p-md-2">
                    <div className="w-100 d-flex">
                        <p className="mb-0 d-inline-block fw-bold">{this.props.warehouse.name} </p>

                        <a className="btn btn-link py-0 ms-auto" onClick={this.openEditWarehouseModal}>
                            <BsPencilSquare />
                        </a>
                        <a className="btn text-danger p-0" onClick={this.delete}>
                            <BsTrash className="" />
                        </a>
                    </div>
                    <small className="d-block">{this.props.warehouse.comments}</small>
                </div>
                <CreateOrEditWarehouseModal
                    modalHandle={this.editWarehouseModal}
                    viewState="edit"
                    warehouseGuid={this.props.warehouse.warehouseGuid}
                />
                <Modal
                    className="modal-sm"
                    title="Confirm Deletion"
                    modalHandle={this.modalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="text-center">{'Delete ' + this.props.warehouse.name + '?'}</div>
                </Modal>
            </div>
        );
    }

    @bind
    private async openEditWarehouseModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        this.editWarehouseModal.open();
    }

    @bind
    private async delete(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        if (await this.modalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask(`Delete Warehouse ${this.props.warehouse.name}`);

            try {
                this.warehouseStore.deleteAsync(this.props.warehouse.warehouseGuid);
                task.complete();
            } catch (e: any) {
                task.error(e);
            }
        }
    }

    private editWarehouseModal = new ModalHandle();
    @observable
    private modalHandle = new ModalHandle();
    @inject
    private appStore!: AppStore;
    @inject
    private tasksStore!: TasksStore;
    @inject
    private warehouseStore!: WarehouseStore;
}
